import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import CloseButton from '../../../../../../../../components/CloseButton'

import './style.scss'

export default class Tab extends Component {
    static propTypes = {
        active: PropTypes.bool,
        id: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired,
        onClick: PropTypes.func,
        onCloseClick: PropTypes.func,
        text: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }

    static defaultProps = {
        active: false,
        onClick: () => {},
        onCloseClick: () => {},
    }

    onTabClick = () => {
        const { id, type, onClick } = this.props

        onClick(id, type)
    }

    onCloseTabClick = () => {
        const { id, type, onCloseClick, index } = this.props

        onCloseClick(id, type, index)
    }

    render() {
        const { active, text, type } = this.props

        return (
            <div className={cx('workspace-tab', `type-${type}`, active && 'active')} onClick={this.onTabClick}>
                <div className={'text'}>{text}</div>
                <div className={'close'}>
                    <CloseButton size={18} onClick={this.onCloseTabClick} />
                </div>
            </div>
        )
    }
}
